import { createElement } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { WrapClientComponent } from '../utils/wrappers-client.util';
import { getStoreAndRouterHistory } from '../modules/redux-client';
import { Logger } from '@as-react/logger';
const rootMap = new Map();
export const RenderClientComponent = async (scene, renderData, node, modules) => {
    if (!renderData?.context)
        return;
    modules.numeral.changeLocal(renderData.context.aemConfiguration.locale);
    const storeAndRouterHistory = await getStoreAndRouterHistory(scene, renderData, modules.redux);
    const wrappedComponent = await WrapClientComponent(scene, renderData, modules.i18n, storeAndRouterHistory);
    try {
        if (rootMap.has(node) && !scene.clientOnly) {
            rootMap.get(node)?.unmount();
            rootMap.delete(node);
        }
    }
    catch (error) {
        Logger.logError(error);
    }
    if (scene.clientOnly) {
        createRoot(node).render(createElement(wrappedComponent));
    }
    else {
        rootMap.set(node, hydrateRoot(node, createElement(wrappedComponent)));
    }
};
